import { Box } from "@mui/material";
import React from "react";
import useTheme from "../../../../../../../common/hooks/useTheme";
import { Theme } from "../../../../../../../providers/ThemeProvider";
import { parseRecipeInstructions } from "../../helpers/recipeInstructionsParser";

type Props = {
  instructionsText: string | undefined | null;
};

/** Numbered steps parsed from the server's instructions text. */
const RecipeInstructionsList = ({ instructionsText }: Props) => {
  const theme: Theme = useTheme();
  const steps = parseRecipeInstructions(instructionsText ?? "");

  if (steps.length === 0) {
    return <Box sx={styles.empty(theme)}>No instructions available.</Box>;
  }

  return (
    <Box sx={styles.list}>
      {steps.map((step) => (
        <Box key={step.stepNumber} sx={styles.step}>
          <Box sx={styles.stepHeader(theme)}>Step {step.stepNumber}</Box>
          <Box sx={styles.instruction(theme)}>{step.instruction}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default RecipeInstructionsList;

const styles = {
  list: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "16px",
  },
  step: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
  },
  stepHeader: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    lineHeight: "20px",
  }),
  instruction: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Regular)",
    fontSize: "14px",
    lineHeight: "22px",
    whiteSpace: "pre-line" as "pre-line",
  }),
  empty: (theme: Theme) => ({
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    fontFamily: "var(--font-Regular)",
    fontSize: "14px",
  }),
};
